<template>
  <BaseModal
    class="modal_video"
    v-on="$listeners"
  >
    <BaseVideo
      ref="video"
      v-bind="$attrs"
      @ended="onVideoEnded"
    />
  </BaseModal>
</template>

<script>
import BaseVideo from '@/components/BaseVideo.vue';
import BaseModal from '@/components/BaseModal.vue';

export default {
  name: 'ModalVideo',
  inheritAttrs: false,
  components: {
    BaseVideo,
    BaseModal,
  },
  props: {
    autoplay: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    this.tryPlay();
  },
  methods: {
    playVideo() {
      return this.$refs.video?.play();
    },
    pauseVideo() {
      return this.$refs.video?.pause();
    },
    tryPlay() {
      if (this.autoplay) {
        this.playVideo();
      }
    },
    onVideoEnded() {
      this.$emit('ended');
    },
  },
};
</script>
